import { getDefaultMargin, getDefaultMarginOverlay, getDefaultTypography, getDefaultWidthOverlay } from '../utils'

export const AudioDesignSettings = {
  'audio-design-width': {
    phone: ['100%'],
    'phone-landscape': ['50%'],
    tablet: ['100%'],
    'tablet-landscape': ['50%'],
    desktop: ['50%'],
    tv: ['50%'],
    overflowSetting: getDefaultWidthOverlay,
  },
  'audio-design-padding': {
    phone: getDefaultMargin([16]),
    'phone-landscape': getDefaultMargin([16]),
    tablet: getDefaultMargin([16]),
    'tablet-landscape': getDefaultMargin([16]),
    desktop: getDefaultMargin([16]),
    tv: getDefaultMargin([16]),
  },
  'audio-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
    overflowSetting: getDefaultMarginOverlay,
  },
  'audio-design-h-align': {
    phone: 'parent',
    'phone-landscape': 'parent',
    tablet: 'parent',
    'tablet-landscape': 'parent',
    desktop: 'parent',
    tv: 'parent',
  },

  //* NESTED
  'audio-design-typography': {
    'audio-design-header-typography': {
      phone: getDefaultTypography('Title Medium'),
      'phone-landscape': getDefaultTypography('Title Medium'),
      tablet: getDefaultTypography('Title Medium'),
      'tablet-landscape': getDefaultTypography('Title Medium'),
      desktop: getDefaultTypography('Title Medium'),
      tv: getDefaultTypography('Title Medium'),
    },
    'audio-design-subheader-typography': {
      phone: getDefaultTypography('Body Small'),
      'phone-landscape': getDefaultTypography('Body Small'),
      tablet: getDefaultTypography('Body Small'),
      'tablet-landscape': getDefaultTypography('Body Small'),
      desktop: getDefaultTypography('Body Small'),
      tv: getDefaultTypography('Body Small'),
    },
    'audio-design-supporting-text-typography': {
      phone: getDefaultTypography('Body Small'),
      'phone-landscape': getDefaultTypography('Body Small'),
      tablet: getDefaultTypography('Body Small'),
      'tablet-landscape': getDefaultTypography('Body Small'),
      desktop: getDefaultTypography('Body Small'),
      tv: getDefaultTypography('Body Small'),
    },
    'audio-design-timer-typography': {
      phone: getDefaultTypography('Body Small'),
      'phone-landscape': getDefaultTypography('Body Small'),
      tablet: getDefaultTypography('Body Small'),
      'tablet-landscape': getDefaultTypography('Body Small'),
      desktop: getDefaultTypography('Body Small'),
      tv: getDefaultTypography('Body Small'),
    },
  },
}
